<template>
    <div class="row">
        <div class="col-md-6">
            <h4 style="color: #4bc0c0;">{{ _t('Main filter') }}</h4>
            <div>
                <div class="row">
                    <div class="col-sm-5 text-left">{{ _t('From week') }}</div>
                    <div class="col-sm-2 hidden-xs text-center">{{ _t('N° weeks') }}</div>
                    <div class="col-sm-5 hidden-xs text-right">{{ _t('To week') }}</div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-xs-6 form-group">
                        <select name="main_week_start" :id="'main_week_start' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('main_week_start-form-label')"
                                :title="_t('main_week_start-form-label')">
                            <option :value="parseInt(week)" v-for="week in statistic.initValues.weeks" :selected="parseInt(week) == mainWeekStart">{{ week }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3 col-xs-6 form-group">
                        <select name="main_year_start" :id="'main_year_start' + statistic.stat" class="form-control select2-rendered"
                            :data-placeholder="_t('main_year_start-form-label')"
                            :title="_t('main_year_start-form-label')">
                            <option :value="year" v-for="year in statistic.initValues.years" :selected="year == mainYearStart">{{ year }}</option>
                        </select>
                    </div>
                    <div class="col-sm-12 col-xs-12 visible-xs text-center">{{ _t('N° weeks') }}</div>
                    <div class="col-sm-2 col-xs-12 text-center form-group">
                        <input type="text" disabled :value="mainNumWeeks" class="form-control text-center" :title="_t('Filled in automatically')"/>
                    </div>
                    <div class="col-sm-6  col-xs-12 visible-xs text-left">{{ _t('To week') }}</div>
                    <div class="col-sm-2 col-xs-6 form-group">
                        <select name="main_week_end" :id="'main_week_end'  + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('main_week_end-form-label')"
                                :title="_t('main_week_end-form-label')">
                            <option :value="parseInt(week)" v-for="week in statistic.initValues.weeks" :selected="parseInt(week) == mainWeekEnd">{{ week }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3 col-xs-6 form-group">
                        <select name="main_year_end" :id="'main_year_end' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('main_year_end-form-label')"
                                :title="_t('main_year_end-form-label')">
                            <option :value="year" v-for="year in statistic.initValues.years" :selected="year == mainYearEnd">{{ year }}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-xs-12 form-group">
                        <select name="main_type" :id="'main_type' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('main_type-form-label')"
                                :title="_t('main_type-form-label')">
                            <option :value="index" v-for="(type, index) in statistic.compareTypes" :selected="index == mainType">{{ type }}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-xs-12 form-group" v-if="statistic.hasCompareStatesFilter">
                        <select name="main_state" :id="'main_state' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('main_state-form-label')"
                                :title="_t('main_state-form-label')">
                            <option :value="index" v-for="(state, index) in statistic.compareStates" :selected="index == mainState">{{ state }}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-xs-12 form-group" v-show="statistic.hasActualizePastFilter">
                        <input name="main_actualize_past"
                            autocomplete="off"
                            checked="checked"
                            type="checkbox"
                            value="1"
                            id="main_actualize_past"
                            class="ios-checkbox"
                            v-model="mainActualizePast"
                        >
                        <label for="main_actualize_past" class="control-label">{{ _t('main_actualize_past-form-label') }}</label>
                    </div>
                    <div class="col-sm-6 col-xs-12 form-group" v-show="statistic.hasShowOwnFilter && consultantLevel.transversal">
                        <input name="main_transversal_extended"
                               autocomplete="off"
                               checked="checked"
                               type="checkbox"
                               value="1"
                               id="main_transversal_extended"
                               class="ios-checkbox"
                               v-model="mainShowOwn"
                        >
                        <label for="main_transversal_extended" class="control-label">{{ _t('main_transversal_extended-form-label') }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <h4 style="color: #ff6384;">{{ _t('Compare filter') }}</h4>
            <div>
                <div class="row">
                    <div class="col-sm-5 text-left">{{ _t('From week') }}</div>
                    <div class="col-sm-2 hidden-xs text-center">{{ _t('N° weeks') }}</div>
                    <div class="col-sm-5 hidden-xs text-right">{{ _t('To week') }}</div>
                </div>

                <div class="row">
                    <div class="col-sm-2 col-xs-6 form-group">
                        <select name="compare_week_start" :id="'compare_week_start' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_week_start-form-label')"
                                :title="_t('compare_week_start-form-label')">
                            <option :value="parseInt(week)" v-for="week in statistic.initValues.weeks" :selected="parseInt(week) == compareWeekStart">{{ week }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3 col-xs-6 form-group">
                        <select name="compare_year_start" :id="'compare_year_start' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_year_start-form-label')"
                                :title="_t('compare_year_start-form-label')">
                            <option :value="year" v-for="year in statistic.initValues.years" :selected="year == compareYearStart">{{ year }}</option>
                        </select>
                    </div>
                    <div class="col-sm-12 col-xs-12 visible-xs text-center">{{ _t('N° weeks') }}</div>
                    <div class="col-sm-2 col-xs-12 text-center form-group">
                        <input type="text" disabled :value="compareNumWeeks" class="form-control text-center" :title="_t('Filled in automatically')"/>
                    </div>
                    <div class="col-sm-6  col-xs-12 visible-xs text-left">{{ _t('To week') }}</div>
                    <div class="col-sm-2 col-xs-6 form-group">
                        <select name="compare_week_end" :id="'compare_week_end' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_week_end-form-label')"
                                :title="_t('compare_week_end-form-label')">
                            <option :value="parseInt(week)" v-for="week in statistic.initValues.weeks" :selected="parseInt(week) == compareWeekEnd">{{ week }}</option>
                        </select>
                    </div>
                    <div class="col-sm-3 col-xs-6 form-group">
                        <select name="compare_year_end" :id="'compare_year_end' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_year_end-form-label')"
                                :title="_t('compare_year_end-form-label')">
                            <option :value="year" v-for="year in statistic.initValues.years" :selected="year == compareYearEnd">{{ year }}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-xs-12 form-group">
                        <select name="compare_type" :id="'compare_type' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_type-form-label')"
                                :title="_t('compare_type-form-label')">
                            <option :value="index" v-for="(type, index) in statistic.compareTypes" :selected="index == compareType">{{ type }}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-xs-12 form-group" v-if="statistic.hasCompareStatesFilter">
                        <select name="compare_state" :id="'compare_state' + statistic.stat" class="form-control select2-rendered"
                                :data-placeholder="_t('compare_state-form-label')"
                                :title="_t('compare_state-form-label')">
                            <option :value="index" v-for="(state, index) in statistic.compareStates" :selected="index == compareState">{{ state }}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-xs-12 form-group" v-show="statistic.hasActualizePastFilter">
                        <input name="compare_actualize_past"
                               autocomplete="off"
                               checked="checked"
                               type="checkbox"
                               value="1"
                               id="compare_actualize_past"
                               class="ios-checkbox"
                               v-model="compareActualizePast"
                        >
                        <label for="compare_actualize_past" class="control-label">{{ _t('compare_actualize_past-form-label') }}</label>
                    </div>

                    <div class="col-sm-6 col-xs-12 form-group" v-show="statistic.hasShowOwnFilter && consultantLevel.transversal">
                        <input name="compare_transversal_extended"
                               autocomplete="off"
                               checked="checked"
                               type="checkbox"
                               value="1"
                               id="compare_transversal_extended"
                               class="ios-checkbox"
                               v-model="compareShowOwn"
                        >
                        <label for="compare_transversal_extended" class="control-label">{{ _t('compare_transversal_extended-form-label') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12">
            <button class="btn btn-primary btn-block btn-filter" @click="applyFilter">
                <i class="fa fa-filter"></i> {{ _t('Apply filter') }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['statistic', 'activeStat'],
        data(){
            return {
                maxRangeWeeks: this.statistic.initValues.maxRangeWeeks,
                mainYearStart: localStorage.mainYearStart || this.statistic.initValues.mainYearStart,
                mainWeekStart: localStorage.mainWeekStart || this.statistic.initValues.mainWeekStart,
                mainYearEnd: localStorage.mainYearEnd || this.statistic.initValues.mainYearEnd,
                mainWeekEnd: localStorage.mainWeekEnd || this.statistic.initValues.mainWeekEnd,
                mainState: localStorage.mainState || this.statistic.initValues.mainState,
                mainActualizePast: localStorage.mainActualizePast || this.statistic.initValues.mainActualizePast,
                mainShowOwn: localStorage.mainShowOwn || this.statistic.initValues.mainShowOwn,
                mainNumWeeks: localStorage.mainNumWeeks || 0,
                mainType: localStorage.mainType || this.statistic.initValues.mainType,
                compareYearStart: localStorage.compareYearStart || this.statistic.initValues.compareYearStart,
                compareWeekStart: localStorage.compareWeekStart || this.statistic.initValues.compareWeekStart,
                compareYearEnd: localStorage.compareYearEnd || this.statistic.initValues.compareYearEnd,
                compareWeekEnd: localStorage.compareWeekEnd || this.statistic.initValues.compareWeekEnd,
                compareState: localStorage.compareState || this.statistic.initValues.compareState,
                compareActualizePast: localStorage.compareActualizePast || this.statistic.initValues.compareActualizePast,
                compareShowOwn: localStorage.compareShowOwn || this.statistic.initValues.compareShowOwn,
                compareNumWeeks: localStorage.compareNumWeeks || 0,
                compareType: localStorage.compareType || this.statistic.initValues.compareType,
                consultantLevel: this.statistic.initValues.consultantLevel,
                groupByConsultantLevel: null,
                table: true,
                getRoute: this.statistic.getRoute,
            }
        },
        created() {

        },
        mounted() {
            let statisticFilter = this;

            statisticFilter.initListeners();

            statisticFilter.applyFilter();

            Event.$on('consultantLevelFilterChanged', function (consultantLevel) {
                statisticFilter.consultantLevel = {
                    id: consultantLevel.value,
                    _lft: consultantLevel._lft,
                    transversal: consultantLevel.transversal,
                };
                statisticFilter.groupByConsultantLevel = null;
                if(statisticFilter.hasShowOwnFilter) {
                    statisticFilter.mainShowOwn = false;
                    statisticFilter.compareShowOwn = false;
                    $("[name='compare_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").removeClass("checked");
                    $("[name='compare_transversal_extended']", statisticFilter.$el).removeAttr('checked');
                    $("[name='main_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").removeClass("checked");
                    $("[name='main_transversal_extended']", statisticFilter.$el).removeAttr('checked');
                }
                statisticFilter.applyFilter();
            });

            Event.$on('groupByConsultantLevelFilterChanged', function (consultantLevel) {
                statisticFilter.groupByConsultantLevel = consultantLevel;
                statisticFilter.applyFilter();
            });
        },
        methods: {
            initListeners: function () {
                let statisticFilter = this;

                $(document).ready(function(){
                    //main
                    $("[name='main_actualize_past']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='compare_actualize_past']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }else{
                            statisticFilter.applyFilter();
                        }
                    });

                    $("[name='main_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='compare_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }else{
                            statisticFilter.applyFilter();
                        }
                    });

                    $(statisticFilter.$el).on("change", "[name='main_year_start']", function(){
                        statisticFilter.mainYearStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_week_start']", function(){
                        statisticFilter.mainWeekStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                        $(statisticFilter.$el).find("[name='compare_week_start']").val($(this).val()).change();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_year_end']", function(){
                        statisticFilter.mainYearEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_week_end']", function(){
                        statisticFilter.mainWeekEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                        $(statisticFilter.$el).find("[name='compare_week_end']").val($(this).val()).change();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_type']", function(){
                        statisticFilter.mainType = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_state']", function(){
                        statisticFilter.mainState = $(this).val();
                    });

                    //compare
                    $("[name='compare_actualize_past']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='main_actualize_past']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }else{
                            statisticFilter.applyFilter();
                        }
                    });

                    $("[name='compare_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").on("click", function(event, triggered){
                        if(!triggered){
                            $("[name='main_transversal_extended']", statisticFilter.$el).next(".ios-ui-select").trigger("click", [true]);
                        }else{
                            statisticFilter.applyFilter();
                        }
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_year_start']", function(){
                        statisticFilter.compareYearStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_week_start']", function(){
                        statisticFilter.compareWeekStart = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_year_end']", function(){
                        statisticFilter.compareYearEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_week_end']", function(){
                        statisticFilter.compareWeekEnd = Number($(this).val());
                        statisticFilter.calcNumWeeks();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_type']", function(){
                        statisticFilter.compareType = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='compare_state']", function(){
                        statisticFilter.compareState = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='group_by_consultant_level']", function(){
                        statisticFilter.groupByConsultantLevel = $(this).val();
                        statisticFilter.applyFilter();
                    });
                });

            },
            applyFilter: function (oldActiveStat) {
                let statisticFilter = this;

                localStorage.mainType = statisticFilter.mainType;
                localStorage.mainYearStart = statisticFilter.mainYearStart;
                localStorage.mainWeekStart = statisticFilter.mainWeekStart;
                localStorage.mainYearEnd = statisticFilter.mainYearEnd;
                localStorage.mainWeekEnd = statisticFilter.mainWeekEnd;
                localStorage.mainState = statisticFilter.mainState;
                localStorage.mainActualizePast = statisticFilter.mainActualizePast;
                localStorage.mainShowOwn = statisticFilter.mainShowOwn;
                localStorage.compareType = statisticFilter.compareType;
                localStorage.compareYearStart = statisticFilter.compareYearStart;
                localStorage.compareWeekStart = statisticFilter.compareWeekStart;
                localStorage.compareYearEnd = statisticFilter.compareYearEnd;
                localStorage.compareWeekEnd = statisticFilter.compareWeekEnd;
                localStorage.compareState = statisticFilter.compareState;
                localStorage.compareActualizePast = statisticFilter.compareActualizePast;
                localStorage.compareShowOwn = statisticFilter.compareShowOwn;

                if(statisticFilter.activeStat.stat != statisticFilter.statistic.stat){
                    return;
                }

                statisticFilter.calcNumWeeks();

                if(statisticFilter.mainNumWeeks != statisticFilter.compareNumWeeks){
                    Swal.fire({
                        text: _t("The N° weeks in the two filters must be equal to apply the filter!"),
                        icon: "warning",
                        showCancelButton: false,
                    });
                }else if(statisticFilter.mainNumWeeks > statisticFilter.maxRangeWeeks){
                    Swal.fire({
                        text: _t('The maximum range permitted is :weeks weeks', {weeks: statisticFilter.maxRangeWeeks}),
                        icon: "warning",
                        showCancelButton: false,
                    });
                }else{
                    Event.$emit('statisticLoading', true);

                    axios.get(this.getRoute, {
                            params: {
                                statistic: statisticFilter.statistic.stat,
                                mainType: statisticFilter.mainType,
                                mainYearStart: statisticFilter.mainYearStart,
                                mainWeekStart: statisticFilter.mainWeekStart,
                                mainYearEnd: statisticFilter.mainYearEnd,
                                mainWeekEnd: statisticFilter.mainWeekEnd,
                                mainState: statisticFilter.mainState,
                                mainActualizePast: statisticFilter.mainActualizePast,
                                mainShowOwn:statisticFilter.mainShowOwn,
                                compareType: statisticFilter.compareType,
                                compareYearStart: statisticFilter.compareYearStart,
                                compareWeekStart: statisticFilter.compareWeekStart,
                                compareYearEnd: statisticFilter.compareYearEnd,
                                compareWeekEnd: statisticFilter.compareWeekEnd,
                                compareState: statisticFilter.compareState,
                                compareActualizePast: statisticFilter.compareActualizePast,
                                compareShowOwn:statisticFilter.compareShowOwn,
                                consultantLevel: statisticFilter.consultantLevel.id,
                                table: true,
                                groupByConsultantLevel: statisticFilter.groupByConsultantLevel,
                            }
                        })
                        .then((res) => {
                            let data = res.data.data;
                            Event.$emit('filterApplied', statisticFilter, data);
                            Event.$emit('statisticLoading', false);
                        })
                        .catch((err) => {
                            console.log(err);
                            Event.$emit('statisticLoading', false);
                        });
                }
            },
            calcNumWeeks: function () {
                let statisticFilter = this;

                statisticFilter.mainNumWeeks = 0;
                for(let year = statisticFilter.mainYearStart; year <= statisticFilter.mainYearEnd; year++){
                    let week_start = 1;
                    let week_end = 52;
                    if(year == statisticFilter.mainYearStart){
                        week_start = statisticFilter.mainWeekStart;
                    }
                    if(year == statisticFilter.mainYearEnd){
                        week_end = statisticFilter.mainWeekEnd;
                    }
                    for(let week = week_start; week <= week_end; week++){
                        statisticFilter.mainNumWeeks++;
                    }
                }

                statisticFilter.compareNumWeeks = 0;
                for(let year = statisticFilter.compareYearStart; year <= statisticFilter.compareYearEnd; year++){
                    let week_start = 1;
                    let week_end = 52;
                    if(year == statisticFilter.compareYearStart){
                        week_start = statisticFilter.compareWeekStart;
                    }
                    if(year == statisticFilter.compareYearEnd){
                        week_end = statisticFilter.compareWeekEnd;
                    }
                    for(let week = week_start; week <= week_end; week++){
                        statisticFilter.compareNumWeeks++;
                    }
                }
            }
        },
        watch: {
            activeStat(newActiveStat, oldActiveStat){
                let statisticFilter = this;

                $("[name='main_type']", statisticFilter.$el).val(localStorage.mainType).trigger("change");
                $("[name='main_year_start']", statisticFilter.$el).val(localStorage.mainYearStart).trigger("change");
                $("[name='main_week_start']", statisticFilter.$el).val(localStorage.mainWeekStart).trigger("change");
                $("[name='main_year_end']", statisticFilter.$el).val(localStorage.mainYearEnd).trigger("change");
                $("[name='main_week_end']", statisticFilter.$el).val(localStorage.mainWeekEnd).trigger("change");
                $("[name='main_state']", statisticFilter.$el).val(localStorage.mainState).trigger("change");
                $("[name='main_actualize_past']", statisticFilter.$el).filter('[value="' + localStorage.mainActualizePast + '"]').prop('checked', true).trigger("change");
                $("[name='main_show_own']", statisticFilter.$el).filter('[value="' + localStorage.mainShowOwn + '"]').prop('checked', true).trigger("change");
                $("[name='compare_type']", statisticFilter.$el).val(localStorage.compareType).trigger("change");
                $("[name='compare_year_start']", statisticFilter.$el).val(localStorage.compareYearStart).trigger("change");
                $("[name='compare_week_start']", statisticFilter.$el).val(localStorage.compareWeekStart).trigger("change");
                $("[name='compare_year_end']", statisticFilter.$el).val(localStorage.compareYearEnd).trigger("change");
                $("[name='compare_week_end']", statisticFilter.$el).val(localStorage.compareWeekEnd).trigger("change");
                $("[name='compare_state']", statisticFilter.$el).val(localStorage.compareState).trigger("change");
                $("[name='compare_actualize_past']", statisticFilter.$el).filter('[value="' + localStorage.compareActualizePast + '"]').prop('checked', true).trigger("change");
                $("[name='compare_show_own']", statisticFilter.$el).filter('[value="' + localStorage.compareShowOwn + '"]').prop('checked', true).trigger("change");
                statisticFilter.mainType = localStorage.mainType;
                statisticFilter.mainYearStart = localStorage.mainYearStart;
                statisticFilter.mainWeekStart = localStorage.mainWeekStart;
                statisticFilter.mainYearEnd = localStorage.mainYearEnd;
                statisticFilter.mainWeekEnd = localStorage.mainWeekEnd;
                statisticFilter.mainState = localStorage.mainState;
                statisticFilter.mainActualizePast = localStorage.mainActualizePast;
                statisticFilter.mainShowOwn = localStorage.mainShowOwn;
                statisticFilter.compareType = localStorage.compareType;
                statisticFilter.compareYearStart = localStorage.compareYearStart;
                statisticFilter.compareWeekStart = localStorage.compareWeekStart;
                statisticFilter.compareYearEnd = localStorage.compareYearEnd;
                statisticFilter.compareWeekEnd = localStorage.compareWeekEnd;
                statisticFilter.compareState = localStorage.compareState;
                statisticFilter.compareActualizePast = localStorage.compareActualizePast;
                statisticFilter.compareShowOwn = localStorage.compareShowOwn;


                this.applyFilter(oldActiveStat.stat);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics/partials/statisticComponentFilter.vue